<template>
    <div>
        <Advantages
            v-if="
                options &&
                options.enableAdvantages &&
                !($scope.HOTSITE_ID && this.$scope.view_counter) &&
                !ignoreBanner
            "
            :hide-regulation="
                !(selected || {}).promo_page &&
                !(
                    $scope.PROMO &&
                    $scope.PROMO.banner_top_link === '/camiseta' &&
                    (selected || {}).type_name === 'Camiseta'
                )
            "
            :class="{
                'display-regulamento':
                    (selected || {}).promo_page || [22, 23].includes($scope.HOTSITE_ID),
            }"
        />

        <!-- <div
            v-if="
                (selected || {}).category === 285 ||
                [22, 23].includes($scope.HOTSITE_ID)
            "
            class="content pt"
        >
            <CatalogQuickFiltersList />
        </div> -->

        <div class="content" v-if="hasMetaTopContent">
            <div class="flex-grid flex-align-center wrapper-header-top">
                <div
                    :class="meta.internal_title ? 'flex-xs-12 flex-md-6 flex-lg-6' : 'flex-md-12'"
                    class="internal_title"
                    v-if="meta.internal_title"
                >
                    <!-- Breadcrumbs -->
                    <CatalogBreadcrumbs v-if="options.enableBreadcrumbs" />
                    <h1
                        class="title text-uppercase text-italic text-left"
                        v-if="(showMessage = true)"
                    >
                        {{ meta.internal_title }}
                    </h1>
                </div>
                <CollapsedContent
                    :class="
                        meta.internal_title
                            ? 'flex-xs-12 flex-md-6 flex-lg-6 pb-2'
                            : 'flex-md-12 py-0'
                    "
                >
                    <div v-html="meta.content_top" />
                </CollapsedContent>
            </div>
        </div>
        <div
            class="content"
            v-else-if="(selected || {}).query != '' && (selected || {}).query != null"
        >
            <div class="flex-grid flex-align-center wrapper-header-top">
                <div class="internal_title flex-md-12">
                    <h1 class="title text-uppercase text-italic text-left">
                        Busca: {{ selected.query }}
                    </h1>
                </div>
            </div>
        </div>

        <div ref="rootAnchor" class="anchor" />

        <CatalogControls class="my content" :show-top-content="!hasMetaTopContent" />

        <div id="catalog-main" class="content">
            <div v-if="showErrorMessage" class="content text-center">
                <div class="alert-danger">
                    <span> {{ $t('_catalog._error.unableToLoad') }}</span>
                    <span v-html="$t('errorContactUsHtml')" />
                </div>
            </div>
            <div
                v-else-if="!products || (products.hits || []).length === 0"
                class="content text-center"
            >
                <img
                    :src="`${$scope.CDN_IMAGES}/images/site/catalog/art-no-results.png?auto=compress,format&q=65&w=100&fit=crop`"
                    :alt="$t('noResults')"
                />
                <p>
                    {{ $t('_catalog._error.noResults') }}
                </p>
            </div>
            <div v-else class="pos-relative">
                <div :class="{ busy: loading }" :style="{ opacity: showSpinner ? 0 : null }">
                    <ProductList
                        :ignore-lazy-load-first-images="true"
                        :current-page="products.current_page"
                        :event-name="listEventName"
                        :item-options="options"
                        :per-page="parseInt(products.per_page)"
                        :products="products.hits"
                        :selected-filters="selected"
                        :adding-product="productAddToCart"
                        :banner-string="storeState.meta.banners_params"
                        @show-add-to-cart-mobile="showAddToCartMobile"
                        list-class="product-list product-list-4 product-list-gap-x-2 product-list-gap-y-4"
                    >
                        <template
                            v-if="!$scope.IS_REGULAR_CUSTOMER"
                            v-slot:below-image="{ product }"
                        >
                            <button
                                class="btn btn-sm btn-light btn-wide hidden-md-down mb-2"
                                @click.stop.prevent="productToBuy = product"
                            >
                                Comprar
                            </button>
                        </template>
                        <template v-slot:list-add-to-cart-desktop="{ product, selectedFabricId }">
                            <ProductListAddToCartDesktop
                                :product="product"
                                :initial-fabric-id="selectedFabricId"
                                :shop-mode="true"
                                class="hidden-xs-down"
                            />
                        </template>
                    </ProductList>
                    <CatalogPagination v-if="options && options.enablePagination" class="mt" />
                </div>
                <div
                    v-if="loading"
                    v-show="showSpinner"
                    class="pos-absolute pos-top pos-left w-full"
                >
                    <Spinner />
                </div>
            </div>
        </div>

        <div v-if="hasMetaBottomContent" class="content">
            <hr />
            <div class="content" v-if="meta.banner_url">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/site/banners/${meta.banner_url}?auto=compress,format&q=65`"
                    alt="banner"
                    class="img-responsive img-lazy center-block"
                />
            </div>
            <div class="description-wrapper">
                <div
                    id="catalog-description"
                    :class="this.fullBottomDescription ? 'expanded' : 'collapsed'"
                    v-html="meta.content_bottom"
                ></div>
                <div id="bottom-description-toggle" @click="toggleBottomDescription">
                    <span>{{ this.fullBottomDescription ? 'Mostrar menos' : 'Mostrar mais' }}</span>
                    <div class="h-divider"></div>
                </div>
            </div>
        </div>

        <ProductQuickBuy
            v-if="productToBuy"
            v-model="productToBuy"
            :product-id="productToBuy.id"
            class="large"
        />

        <SalesRepCartCustomerManager />

        <ProductListAddToCartMobile
            v-if="productAddToCart"
            :product="productAddToCart"
            :initial-fabric-id="productAddToCartFabricId"
            :initial-model-url="(selected || {}).model_url"
            :initial-size-name="(selected || {}).size"
            @close="
                productAddToCart = null;
                productAddToCartFabricId = null;
            "
            class="add-to-cart-mobile"
        />
    </div>
</template>

<script>
    import Spinner from '../../../../../submodules/src/components/feedback/spinner/Spinner.vue';
    import { catalogStore } from '../../common/store/catalog-store';
    import { EventBus, resizeOrientationAware, storageWrapper } from '../../../common/common';
    import Advantages from '../common/Advantages';
    import ProductList from '../common/ProductList';
    import CollapsedContent from '../common/container/CollapsedContent';
    import ProductQuickBuy from '../product/ProductQuickBuy';
    import SalesRepCartCustomerManager from '../sales-rep/SalesRepCartCustomerManager';
    import CatalogControls from './CatalogControls';
    import CatalogPagination from './CatalogPagination';
    import CatalogBreadcrumbs from './CatalogBreadcrumbs';
    import CatalogQuickFiltersList from './CatalogQuickFiltersList';
    import ProductListAddToCartMobile from '../product/ProductListAddToCartMobile.vue';
    import ProductListAddToCartDesktop from '../product/ProductListAddToCartDesktop.vue';

    export default {
        name: 'Catalog',

        components: {
            ProductListAddToCartDesktop,
            ProductListAddToCartMobile,
            CatalogQuickFiltersList,
            CollapsedContent,
            ProductQuickBuy,
            CatalogControls,
            SalesRepCartCustomerManager,
            Advantages,
            ProductList,
            CatalogPagination,
            Spinner,
            CatalogBreadcrumbs,
        },

        data() {
            return {
                storeState: catalogStore.state,
                showErrorMessage: false,
                productToBuy: null,
                showSpinner: false,
                recentSearches: JSON.parse(storageWrapper.getItem('recentSearches')) || [],
                fullBottomDescription: false,
                isMobile: false,
                resizeAwareRemoveCb: null,

                productAddToCart: null,
                productAddToCartFabricId: null,
                showProductAddedToCart: null,
            };
        },

        watch: {
            meta: {
                deep: true,
                handler(val) {
                    if (!val) return;

                    if (val.title) {
                        document.title = val.title;
                    }
                    if (val.description) {
                        let el = document.querySelector("meta[name='description']");

                        if (!el) {
                            el = document.createElement('meta');
                            el.setAttribute('name', 'description');
                            document.head.append(el);
                        }

                        el.setAttribute('content', val.description);
                    }
                    if (val.canonical) {
                        let el = document.querySelector("link[rel='canonical']");

                        if (!el) {
                            el = document.createElement('link');
                            el.setAttribute('rel', 'canonical');
                            document.head.append(el);
                        }
                        el.setAttribute('href', location.origin + val.canonical);
                    }
                },
            },

            selected: {
                immediate: true,
                handler(to) {
                    if (to) {
                        window.dataLayer.push({
                            'product-category-id': to.category ? to.category : to.type_id,
                            'product-category-name': to.category_name
                                ? to.category_name
                                : to.partner_name
                                ? to.partner_name
                                : to.type_name,
                            'product-gender-category': to.gender_name ? to.gender_name : '',
                            google_tag_params: {
                                ecomm_pagetype: 'category',
                                ecomm_category: to.category_name
                                    ? to.category_name
                                    : to.partner_name
                                    ? to.partner_name
                                    : to.type_name,
                            },
                            'product-list-criteo':
                                ((this.products || {}).hits || []).length > 0
                                    ? this.products.hits.slice(0, 4).map((p) => p.id + '')
                                    : [],
                        });
                    }
                },
            },

            loading(to) {
                if (to) {
                    this.scrollToTop();
                    setTimeout(() => {
                        if (this.loading) {
                            this.showSpinner = true;
                        }
                    }, 3000);
                } else {
                    this.showSpinner = false;
                }
            },
        },

        computed: {
            products() {
                return (this.storeState || {}).products;
            },

            meta() {
                return (this.storeState || {}).meta;
            },

            options() {
                return (this.storeState || {}).options;
            },

            filters() {
                return (this.storeState || {}).filters;
            },

            selected() {
                return (this.storeState || {}).selected;
            },

            loading() {
                return (this.storeState || {}).loading;
            },

            gender() {
                const gender = this.selected ? this.selected.gender : null;
                return gender === 'M' ? 1 : gender === 'F' ? 2 : 0;
            },

            listEventName() {
                if (this.selected) {
                    return (
                        (this.selected.partner_name ? this.selected.partner_name + ' - ' : '') +
                        (this.selected.type_main_url ? this.selected.type_main_url : '') +
                        (this.selected.type_name ? ' - ' + this.selected.type_name : '') +
                        (this.selected.category_name ? ' - ' + this.selected.category_name : '') +
                        (this.selected.model_name ? ' - ' + this.selected.model_name : '')
                    );
                } else {
                    return null;
                }
            },

            hasMetaTopContent() {
                return !this.isMetaContentEmpty((this.meta || {}).content_top);
            },

            hasMetaBottomContent() {
                return !this.isMetaContentEmpty((this.meta || {}).content_bottom);
            },

            ignoreBanner() {
                return Number(this.storeState.meta.ignore_banner);
            },
        },

        mounted() {
            this.resizeAwareRemoveCb = resizeOrientationAware(() => {
                this.isMobile = window.innerWidth < 768;
            }, true);
        },

        beforeDestroy() {
            this.resizeAwareRemoveCb();
        },

        created() {
            EventBus.$on('list-product-added-to-cart-mobile', this.addedToCartFromListing);

            if (this.products && this.products.per_page != '36' && this.products.per_page) {
                const url = new URL(window.location.href);
                url.searchParams.set('per_page', this.products.per_page);
                window.history.replaceState('', '', url.toString());
            }

            if (this.selected && this.selected.query != '' && this.selected.query != null) {
                this.recentSearches.push(this.selected.query);
                const index = this.recentSearches.indexOf(this.selected.query);
                if (index < 0 || index >= this.recentSearches.length - 1) {
                    storageWrapper.setItem('recentSearches', JSON.stringify(this.recentSearches));
                }
            }
        },

        methods: {
            scrollToTop() {
                cr$.byEl(this.$refs.rootAnchor).scrollIntoView(500);
            },

            isMetaContentEmpty(metaContent) {
                if (!metaContent || metaContent.length === 0) {
                    return true;
                }

                const fakeEl = document.createElement('div');
                fakeEl.innerHTML = metaContent;
                return fakeEl.textContent.length === 0;
            },

            toggleBottomDescription() {
                cr$.byId('catalog-description').scrollIntoView(500, this.isMobile ? -45 : -70);
                setTimeout(
                    () => {
                        this.fullBottomDescription = !this.fullBottomDescription;
                    },
                    this.fullBottomDescription ? 500 : 0
                );
            },

            showAddToCartMobile({ product, fabricId }) {
                this.productAddToCart = product;
                this.productAddToCartFabricId = fabricId;
                const id = this.productAddToCart.id + `-productRef`;
                cr$.byId(id).scrollIntoView(500, -55);
            },

            addedToCartFromListing() {
                this.showProductAddedToCart = 'produto adicionado à sacola com sucesso';

                setTimeout(() => {
                    this.showProductAddedToCart = null;
                }, 2500);
            },
        },
    };
</script>
